// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2IhVz","title":"styles_title__3FSv3"};